import { useFela } from 'react-fela';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Empty from 'antd/lib/empty';
import Alert from 'antd/lib/alert';

import Pin, { pinShape } from '../Pin';

import rule from './PinsList.rule';

const PinsList = ({ pins }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <h3>
                <FormattedMessage id="pins.list.title" />
            </h3>
            <Alert message={<FormattedMessage id="pins.list.alert" />} type="info" />
            {pins.map(pin => (
                <Pin key={pin.id} id={pin.id} title={pin.title} />
            ))}
            {!pins.length && <Empty />}
        </div>
    );
};

PinsList.propTypes = {
    pins: PropTypes.arrayOf(pinShape).isRequired,
};

export default PinsList;
